import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

// import { KeyValuePipe } from './key-value.pipe';
import { ProgressIconComponent } from "./progress-icon/progress-icon.component";
import { CompoundComponent } from "./compound/compound.component";
import { CompoundButtonComponent } from "./compound-button/compound-button.component";
import { OnleaTableComponent } from "./onlea-table/onlea-table.component";

import { SamplesListComponent } from "./home-sidebar/samples-list.component";

import { TutorialModalComponent } from "./home-sidebar/tutorial-modal/tutorial-modal.component";
import { FeedbackModalComponent } from "./home-sidebar/feedback-modal/feedback-modal.component";
import { AchievementsModalComponent } from "./home-sidebar/achievements-modal/achievements-modal.component";
import { AccountDeleteModalComponent } from "./home-sidebar/account-delete-modal/account-delete-modal.component";

import {
  DataInspectComponent,
  SampleSyncDataComponent,
} from "./data-inspect/data-inspect.component";
import { AppVersionComponent } from "./app-version/app-version.component";
import { TopMenuComponent } from "./top-menu/top-menu.component";
import { MenuBtnComponent } from "./top-menu/menu-btn/menu-btn.component";
import { ReactiveFormsModule } from "@angular/forms";
import { PwaInstallComponent } from "./pwa-install/pwa-install.component";

/**
 * Provides shared components for the whole app
 */
@NgModule({
  declarations: [
    // KeyValuePipe,
    ProgressIconComponent,
    CompoundComponent,
    CompoundButtonComponent,
    OnleaTableComponent,
    TutorialModalComponent,
    FeedbackModalComponent,
    AchievementsModalComponent,
    AccountDeleteModalComponent,
    SamplesListComponent,
    DataInspectComponent,
    SampleSyncDataComponent,
    AppVersionComponent,
    TopMenuComponent,
    MenuBtnComponent,
    PwaInstallComponent,
  ],
  exports: [
    // KeyValuePipe,
    ProgressIconComponent,
    CompoundComponent,
    CompoundButtonComponent,
    OnleaTableComponent,
    SamplesListComponent,
    DataInspectComponent,
    AppVersionComponent,
    TopMenuComponent,
    MenuBtnComponent,
    PwaInstallComponent,
  ],
  imports: [IonicModule, CommonModule, FormsModule, ReactiveFormsModule],
})
export class SharedModule {}
